import {gql} from '@apollo/client'

export const DASHBOARD_ALERTS = gql`
  query dashboardAlerts {
    client {
      contractAlertEmployees {
        id
        displayFullName
      }
      visaAlertEmployees {
        id
        displayFullName
        visaHistory {
          id
          visaUntil
        }
      }
      commentAlerts {
        totalCount
        comments {
          id
          body
          color
          alertAt
          commentable {
            __typename
            ... on Employee {
              id
              displayFullName
              staffCode
            }
          }
        }
      }
    }
    employeeAlertsOnDashboard {
      id
      name
      color
      employeeAlerts {
        id
        alertStart
        employee {
          id
          displayFullName
          staffCode
        }
      }
    }
  }
`

export interface DashboardAlertsQueryResult {
  client: {
    contractAlertEmployees: ContractAlertEmployee[]
    visaAlertEmployees: VisaAlertEmployee[]
    commentAlerts: CommentAlerts
  }
  employeeAlertsOnDashboard: AlertType[]
}

export interface ContractAlertEmployee {
  id: string
  displayFullName: string
}

export interface VisaAlertEmployee {
  id: string
  displayFullName: string
  visaHistory: {
    id: string
    visaUntil: string
  }
}

export interface CommentAlerts {
  totalCount: number
  comments: Comment[]
}

interface Comment {
  id: string
  body: string
  color: string
  alertAt: string
  commentable: Employee
}

export interface AlertType {
  id: string
  name: string
  color: number
  employeeAlerts: EmployeeAlert[]
}

interface EmployeeAlert {
  id: string
  alertStart: string
  employee: Employee
}

interface Employee {
  id: string
  staffCode: string
  displayFullName: string
}
